import { render, staticRenderFns } from "./CadastroParametros.vue?vue&type=template&id=74bfe967&"
import script from "./CadastroParametros.vue?vue&type=script&lang=js&"
export * from "./CadastroParametros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports